import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// The named type scale in tailwind.config (text-caption, text-label, …) must be
// registered as FONT SIZES. Unregistered, tailwind-merge reads `text-caption-medium`
// as a text COLOUR and deletes it whenever a real colour (text-uzo-mut) follows —
// the Knowledge Bases toolbar tabs lost their 12px size that way (2026-09-25).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{
        text: [
          "page-title", "section-title", "card-title", "modal-title",
          "body", "body-medium", "table", "label", "caption", "caption-medium", "code",
        ],
      }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
